import styles from './ReplayOverlay.module.scss';
import { useRef } from 'react';
import {
  EBaseButtonSize,
  EBaseButtonType,
  EButtonBorderRadiusStrength,
  EButtonTextAlign,
} from '@spinwise/react-component-library/ButtonAbstract';
import { EBrandIconVariants } from '../../../../../../libraries/variants.library';
import { IconLibrary } from '../../../../../../libraries/icons.library';
import { t } from 'i18next';
import RegisterBtnManager from '../../../../../shared/Header/buttons/RegisterBtnManager';
import { EBrandButtonTypes } from '../../../../../../libraries/buttons.library';
import { IApplicationState } from '@spinwise/spinwise-core';
import { useSelector } from 'react-redux';
import useScreenBreakpoint from 'Hooks/useScreenBreakpoints';
import { ButtonIconOnly } from '@spinwise/react-component-library/ButtonIconOnly';
import { ButtonTextOnly } from '@spinwise/react-component-library/ButtonTextOnly';

const MOBILE_WIDTH = 834;
interface IReplayOverlay {
  content: { icon: any; link: string; name: string; provider: string };
  onClickClose: Function;
}
const ReplayOverlay = ({ content, onClickClose }: IReplayOverlay) => {
  const refModal = useRef<HTMLDivElement>();

  const isMobile = useScreenBreakpoint(MOBILE_WIDTH);

  const reg_type = useSelector((state: IApplicationState) => state.globalReducer.geo.reg_type);
  const code = useSelector((state: IApplicationState) => state.globalReducer.geo.code);

  const getPromoText = (value: String) => {
    if (['SWE', 'NOR'].includes(code)) {
      return t(`swe.${reg_type}.${value}`);
    }
    return t(`${reg_type}.${value}`);
  };

  return (
    <>
      <div
        ref={refModal}
        className={`${styles.modal_container}`}
        style={{
          height: `${
            isMobile == false
              ? `${refModal.current?.clientWidth ? `${(refModal.current.clientWidth / 16) * 9}px` : '0px'}`
              : '100vh'
          }`,
        }}
      >
        <div className={styles.iframe_container}>
          <div className={`${styles.top_container} d-fl `}>
            <div className={`${styles.close_icon} d-fl ai-c jc-c`}>
              <ButtonIconOnly
                onClick={() => onClickClose()}
                size={EBaseButtonSize.Medium}
                type={EBaseButtonType.None}
                iconName={IconLibrary.CrossSm}
                variant={EBrandIconVariants.Default}
              />
            </div>
          </div>
          <div className={styles.iframe_gradient}></div>
          <iframe src={content.link} frameBorder="0" scrolling="no"></iframe>
        </div>
        <div className={`${styles.ui_container} d-fl jc-sb ai-fe`}>
          <div className={`${styles.container_left} d-fl ai-c`}>
            <img className={styles.thumbnail_icon} src={content.icon?.url} alt="" />
            <div className={styles.thumbnail_name_container}>
              <p className={styles.name}>{content.name}</p>
              <p className={styles.provider}>{content.provider}</p>
            </div>
          </div>
          <div className={`${styles.container_right} ai-c`}>
            <p>{getPromoText('homepage.b.replay.overlay.offer')}</p>
            {/* <div className={styles.deposit_button}>
              <p>{t('homepage.b.replay.overlay.offer')}</p>
            </div> */}
            <RegisterBtnManager
              Component={ButtonTextOnly}
              propsComponent={{
                label: 'homepage.b.replay.overlay.offer.btn',
                size: EBaseButtonSize.Large,
                type: EBrandButtonTypes.Tertiary,
                borderRadius: EButtonBorderRadiusStrength.Eight,
                fullWidth: true,
                alignText: EButtonTextAlign.Center,
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default ReplayOverlay;
